import {gql, useQuery} from "@apollo/client";
import React from "react";
import ChannelStateEvent from "./ChannelStateEvent";
import CallEvent from "./CallEvent";
import {getSession} from "./types/getSession";

const SESSION_QUERY = gql`
    query getSession {
        session {
            pbxIsOffhook
        }
    }`

/**
 * Opens the live-call stream this user's PBX speaks: the call-event contract
 * for a company on an offhook instance, the FreeSWITCH channel states for one
 * on FusionPBX. The server answers only on the matching one, so the choice is
 * made once here rather than in every activity view.
 *
 * Children render throughout, including while the answer is still in flight:
 * a moment without events is what a quiet phone looks like anyway.
 */
export default function CallStateStream(props: { dispatch: React.Dispatch<any>, children: React.ReactNode }) {
    const { data, loading, error } = useQuery<getSession>(SESSION_QUERY);

    if (loading || error) {
        return <>{props.children}</>
    }

    return data?.session?.pbxIsOffhook
        ? <CallEvent dispatch={props.dispatch}>{props.children}</CallEvent>
        : <ChannelStateEvent dispatch={props.dispatch}>{props.children}</ChannelStateEvent>
}
